module.exports = __webpack_public_path__ + "static/media/HEART-8.5f27a88c.svg";